export default __webpack_public_path__ + "static/heroSectionImg-6dc3a3b60d5cc94ae8940d72015cd283.webp";